import axios from "axios";
import { toast } from "react-toastify";

// 🌐 Base URL vinda do .env ou fallback local
const baseURL =
  process.env.REACT_APP_API + "/api"

console.log(`🌍 API baseURL: ${baseURL}`);

// 🧠 Instância principal do Axios
const api = axios.create({
  baseURL,
  timeout: 60000, // evita travar o front se o servidor cair
});

// 🔐 Intercepta e injeta tokens (JWT e WhatsApp)
api.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem("token");
    const whatsToken = localStorage.getItem("whatsToken");

    // Token JWT da aplicação
    if (jwtToken) {
      config.headers.Authorization = `Bearer ${jwtToken}`;
    }

    // Token do WhatsApp (identificação da instância)
    if (whatsToken) {
      config.headers["x-whats-token"] = whatsToken;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ⏰ Logoff automático após 1 hora
const LOGOFF_TIMEOUT_MS = 60 * 60 * 1000; // 1 hora
if (localStorage.getItem("token")) {
  if (!window.__logoffTimeoutSet) {
    window.__logoffTimeoutSet = true;
    setTimeout(() => {
      localStorage.removeItem("token");
      toast.info("Sessão encerrada por inatividade. Faça login novamente.");
      window.location.href = "/login";
    }, LOGOFF_TIMEOUT_MS);
  }
}

// 🚨 Intercepta respostas de erro (ex: expiração de token)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.error || error.message;

    // Token expirado → redireciona para login
    if (status === 401) {
      console.warn("⚠️ Token expirado — redirecionando para login");
      localStorage.removeItem("token");
      toast.warn("Sua sessão expirou, faça login novamente.");
      window.location.href = "/login";
    } else if (status >= 500) {
      console.error("💥 Erro interno do servidor:", message);
      toast.error("Erro interno no servidor. Tente novamente mais tarde.");
    } else if (status >= 400) {
      console.warn("⚠️ Erro na requisição:", message);
      toast.warn(message);
    }

    return Promise.reject(error);
  }
);

export default api;
